import React from 'react';
import { TableRow, TableCell } from '@material-ui/core';

interface EmptyRowProps {
  emptyRows: number;
  bgColor?: string;
  height?: string;
}

const EmptyRow = ({
  emptyRows,
  bgColor = '#eeeeee',
  height = '1rem'
}: EmptyRowProps) => {
  return (
    <TableRow>
      {[...Array(emptyRows)].map((empty: any, index: number) => (
        <TableCell
          style={{
            backgroundColor: bgColor,
            height: height,
            borderBottom: 0,
            padding: 0
          }}
          key={index}
        ></TableCell>
      ))}
    </TableRow>
  );
};

export default EmptyRow;
